
export default function Services() {
  const services = [
    {
      icon: 'ri-user-star-line',
      title: 'Professional Staff',
      description: 'Highly trained waiters and staff to provide exceptional service at your event.',
      image: 'https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/53ddd27b670179596d66d76075a2e150.jpeg'
    },
    {
      icon: 'ri-restaurant-2-line',
      title: 'Premium Catering',
      description: 'Customized menus with top-quality ingredients and impeccable presentation.',
      image: 'https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/6b5dce13024c30f17e7451c6e305bd91.jpeg'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Complete Organization',
      description: 'Comprehensive planning of your event from start to the last detail.',
      image: 'https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/7e3cb83f04d92c9e9e3645208f9b12a5.jpeg'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Elegant Decoration',
      description: 'Sophisticated and personalized ambiance that reflects your unique style.',
      image: 'https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/8a38d3144fcfc966522f240e2c520e14.jpeg'
    },
    {
      icon: 'ri-time-line',
      title: 'Event Coordination',
      description: 'Professional supervision throughout the event to ensure everything flows perfectly.',
      image: 'https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/5e7f2eeb129b4a253375a206a6fbd6cf.jpeg'
    },
    {
      icon: 'ri-heart-line',
      title: 'Personalized Service',
      description: 'Dedicated attention to your specific needs to create a unique experience.',
      image: 'https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/d21216cd34d6f50585d0abcb154d1e90.jpeg'
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#F5F5F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-6 py-2 bg-[#D4AF37]/10 rounded-full border border-[#D4AF37]/20">
            <span className="text-[#D4AF37] text-sm font-semibold tracking-wide">OUR SERVICES</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gray-900 font-bold mb-6">
            Excellence in<br />Service
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            We offer a wide range of services to make your event a unique and memorable experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 group cursor-pointer"
            >
              {service.image && (
                <div className="w-full h-56 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              )}
              <div className="p-8">
                <div className="w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#C5A028] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-[#D4AF37] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#C5A028] transition-all transform hover:scale-105 inline-flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg"
          >
            Request Information
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
